import * as _ from 'lodash';
import { AxiosError } from 'axios';
import { client } from '../http';
import router from '../../router';

function init() {
  function handleNotAuthorized(error: AxiosError) {
    const status = error?.response?.status;
    if (status === 403) {
      const query = {
        redirectTo: encodeURIComponent(_.trimStart(window.location.pathname, '/')),
        ...router.currentRoute.value.query,
      };
      const qs = new URLSearchParams(_.toPairs(query)).toString();
      /*
       * We reload the page and not use Vue Router to redirect to the login page
       * to make sure that all other HTTP requests are cancelled and won't
       * cause additional redirects after we navigate
       */
      window.location.assign(`/login?${qs}`);
    }
    return Promise.reject(error);
  }

  client.interceptors.response.use(
    response => response,
    handleNotAuthorized,
  );
}

export default { init };
